<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MITs -->
<div 
  *ngIf="showAlert" 
  class="font-awesome-alert"
  role="alert"
  aria-live="polite"
  aria-atomic="true">
  <ngb-alert 
    type="warning" 
    [dismissible]="true"
    (close)="dismissAlert()"
    animation="true"
    class="font-awesome-warning-alert">
    
    <div class="d-flex align-items-start">
      <!-- Use a simple text icon as fallback since Font Awesome may not be working -->
      <span class="alert-icon me-2" aria-hidden="true">!</span>
      
      <div class="flex-grow-1">
        <h6 class="alert-heading mb-2">
          Icon Loading Issue Detected
        </h6>
        <p class="mb-2">
          There seems to be an issue loading icons from the Font Awesome CDN. 
          Icons are now using a public Font Awesome fallback for continuity.
        </p>
        <div class="d-flex gap-2">
          <button 
            type="button" 
            class="btn btn-sm btn-outline-secondary"
            (click)="dismissAlert()">
            Dismiss
          </button>
        </div>
        <small class="text-muted mt-2 d-block">
          This may be due to network connectivity issues or CDN availability. 
          The application will continue to work with fallback icons.
        </small>
      </div>
    </div>
  </ngb-alert>
</div>
